import {
  Paper,
  styled,
  Table,
  TableBody,
  TableCell as MuiTableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";

type Props = {
  titles: Array<string>;
  data: Array<{ [key: string]: string }>;
};

const Tables = ({ titles, data }: Props) => {
  const names: Array<string> = Object.keys(data[0]);

  const TableCell = styled(MuiTableCell)(({ theme }) => ({
    fontSize: 16,
    lineHeight: "22px !important",
  }));

  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead
          sx={{ backgroundColor: "primary.main", color: "text.primary" }}
        >
          <TableRow>
            {titles.map((title, i) => (
              <TableCell sx={{ border: 1 }}>{title}</TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((objs, i) => (
            <TableRow>
              {titles.includes("Sr.No.") ? (
                <TableCell sx={{ color: "primary.main", border: 1 }}>
                  {i + 1}
                </TableCell>
              ) : (
                ""
              )}
              {names.map((name, i) => (
                <TableCell sx={{ color: "primary.main", border: 1 }}>
                  {objs[name]}
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default Tables;
